import { SiteBanner } from './SiteBanner';

export default SiteBanner;
